import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Algo deu errado. Tente de novo.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? fallback : "Sem conexão. Verifique sua internet.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Confira os campos preenchidos.";
  return d.msg || fallback;
}

export const fileUrl = (p) => (p ? `${API}/files/${p}` : null);

export function waLink(phone, text = "") {
  let d = (phone || "").replace(/\D/g, "");
  if (d.length <= 11) d = `55${d}`;
  return `https://wa.me/${d}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export const km = (v) => (v == null ? "" : `${String(v).replace(".", ",")} km`);

export const priceLabel = (r) =>
  r?.price_type === "valor" && r.price ? `Oferece R$ ${Number(r.price).toLocaleString("pt-BR")}` : "Valor a combinar";

export const PAYMENT_NOTE = "O site não cobra nem intermedeia o pagamento do serviço. Depois do aceite, cliente e prestador combinam direto pelo WhatsApp.";

export const STATUS_LABEL = {
  novo: "Novo",
  buscando: "Buscando prestador",
  aguardando: "Aguardando prestador",
  aceito: "Aceito",
  concluido: "Concluído",
  cancelado: "Cancelado",
  sem_prestador: "Sem prestador",
};

export const STATUS_COLOR = {
  novo: "bg-slate-100 text-slate-700",
  buscando: "bg-orange-100 text-orange-800",
  aguardando: "bg-amber-100 text-amber-800",
  aceito: "bg-green-100 text-green-800",
  concluido: "bg-slate-800 text-white",
  cancelado: "bg-red-100 text-red-700",
  sem_prestador: "bg-yellow-100 text-yellow-800",
};
